import { ApiUtility } from "./ApiUtility";

class HomeServices {
  route = "/posts";
  homeRoute = "/api/settings/homepage?lang=";
  messageRoute = "/api/messages?lang=";
  messageIdRoute = "/api/articles/";
  allauthorRoute = "/api/Authors/5bbc60101fd2d735b0087d36?lang=";
  contactRoute = "/api/Settings/contactus";
  magzines = "/api/magazines";
  recentViewRoute = "/api/user/recentviewlatest?";
  recentViewDeleteRoute = "/api/user/recentview";
  bannerRoute = "/api/banners";

  getHomeData = (lang: string, mode?: number) => {
    const modeParam = mode !== undefined ? `&mode=${mode}` : '';
    return ApiUtility.get(
      this.homeRoute +
      lang +
      modeParam
    );
  };

  getmagzine = (start: any, length: any) => {
    return ApiUtility.get(
      this.magzines + start + "&length=" + length
    )
  }

  getmagzinepost = (start: number, length: number) => {
    return ApiUtility.post(this.magzines, {
      start,
      length,
      lang: localStorage.getItem("lan") || "hindi",
    });
  };

  getMessage = (lang: string, start: number, length: number) => {
    return ApiUtility.get(
      this.messageRoute +
      "&lang" +
      lang +
      "$start" +
      start +
      "&length=" +
      length
    );
  };

  getMessageId = (id: string, lang: string) => {
    return ApiUtility.get(this.messageIdRoute + id + "?lang=" + lang);
  };

  postcontact = (params: any) => {
    return ApiUtility.post(this.contactRoute, params);
  };

  sendFeedback = (
    name: string,
    phoneNumber: string,
    email: string,
    feedbacktype: string,
    comment: string
  ) => {
    if (!feedbacktype) {
      feedbacktype = "1";
    }
    return ApiUtility.post(
      this.contactRoute,
      {
        contactType: feedbacktype,
        name: name,
        phoneNumber: phoneNumber,
        email: email,
        userId: "",
        messageContent: comment,
        medium: "1",
      },

    );
  }

  deleteRecentView = (recent: number) => {
    return ApiUtility.delete(this.recentViewDeleteRoute + `?recent=${recent}`);
  };

  getRecentViews = (lang: string, length: number) => {
    return ApiUtility.get(
      this.recentViewRoute +
      "lang=" + lang +
      "&length=" + length
    );
  };

  getbanners = (lang: string, length: number) => {
    return ApiUtility.get(
      this.bannerRoute +
      "?lang=" + lang +
      "&length=" + length
    );
  }
}
export default new HomeServices();
